import React, { useEffect } from "react";
import { Modal, Form, Input, Button } from "antd";

const AddFacilityModal = ({ visible, onCancel, onOk, facility }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (facility) {
      form.setFieldsValue({
        name: facility.name,
        color: facility.color,
      });
    } else {
      form.resetFields();
    }
  }, [facility, form, visible]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      onOk(values);
      form.resetFields();
    });
  };

  return (
    <Modal
      title={facility ? "Edit Additional Tool" : "Add Additional Tool"}
      open={visible}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      footer={null}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Please enter sample size name' }]}>
          <Input />
        </Form.Item>
        <Form.Item className="">
          <div className="d-flex justify-content-center gap-3">

          <Button className="inviteButtonTPM" onClick={onCancel}>Cancel</Button>
          <Button className="addButtonTPM" type="primary" onClick={handleSubmit} style={{ marginRight: 8 }}>
            {facility ? "Edit Additional Tool" : "Add Additional Tool"}
          </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddFacilityModal; 